import axios from 'axios'

export const productApi = {

    GetProduct({ skuid } = {}) {
        return axios
            .get('/api/v1/product/getproduct?skuid=' + skuid)
            .then((response) => {
                return response.data
            })
    },

    GetProductComplete({ skuid } = {}) {
        return axios
            .get('/api/v1/product/getproductcomplete?skuid=' + skuid)
            .then((response) => {
                return response.data
            })
    },

    GetCategories({ } = {}) {
        return axios
            .get('/api/v1/product/getcategories')
            .then((response) => {
                return response.data
            })
    },

    searchProducts({ page, departmentId, categoryId, search, ordination } = {}) {
        return axios
            .get('/api/v1/product/searchproducts?page='+page + '&departmentId=' + departmentId + '&categoryId=' + categoryId + '&search=' + search + '&ordination=' + ordination)
            .then((response) => {
                return response.data
            })
    },    

}
